import { render } from "./ChinaMaker.vue?vue&type=template&id=18d687fc&scoped=true"
import script from "./ChinaMaker.vue?vue&type=script&lang=js"
export * from "./ChinaMaker.vue?vue&type=script&lang=js"

import "./ChinaMaker.vue?vue&type=style&index=0&id=18d687fc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d687fc"]])

export default __exports__